import { UsercentricsEvent } from './interfaces';

const getDistributorCodes = ({ detail: { services } }: UsercentricsEvent): Array<string> => {
  const result: Array<string> = [];
  for (const key in services) {
    if (key in services) {
      const service = services[key];
      if (service.consent?.given) {
        result.push(service.name);
      }
    }
  }

  return result;
};

export default getDistributorCodes;
